export default __webpack_public_path__ + "static/start-header-726610aa6615aadb81278d1fa60575ea.png";